import React, { useEffect } from "react";

import "./CategoryCollection.scss";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrderedCategoryCollection } from "../../Reducers/actions/ordersActions";
import { useNavigate, useParams } from "react-router-dom";
import CreationCard from "../../components/CreationCard/CreationCard";
import { setTopNavbar } from "../../Reducers/actions/navbarActions";
import { capitalizeFirstLetter } from "../../../helpers/utilities";
import Icon from "../../components/Icon/Icon";
import { categoriesProps } from "../../components/Library/CategoryGrid";
import CreationSkeleton from "../../components/CreationCard/CreationSkeleton";

function CategoryCollection() {
    const { collection_category } = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { userId, categoryCollectionLoading, categoryCollection } = useSelector(
        (state) => ({
            userId: state?.auth?.session?.user?.id,
            categoryCollection: state?.orders?.category_collection,
            categoryCollectionLoading: state?.orders?.loading_category_collection,
        })
    );

    useEffect(() => {
        if (userId && collection_category) {
            dispatch(setTopNavbar({
                showBackArrow: true,
                title: `${capitalizeFirstLetter(collection_category?.replace('_', ' ') || "")} Collection`
            }))
            dispatch(fetchOrderedCategoryCollection(collection_category));
        }
    }, [userId, collection_category]);

    const handleCardClick = (creation_id) => {
        navigate(`/creations/${creation_id}`);
    };

    if (categoryCollectionLoading) {
        return (<div className="collection-container">
            {[1, 2, 3].map((item) => <CreationSkeleton key={item} />)}
        </div>)

    }

    const categoryProp = categoriesProps?.find(cat => cat.value === collection_category);

    return (
        <div className="collection-container">

            {categoryCollection?.length ? categoryCollection?.map((row) => (
                <CreationCard
                    key={row?.creation_id}
                    thumbnailUrl={row?.creation_data?.thumbnail_url}
                    category={row?.creation_data?.category}
                    title={row?.creation_data?.title}
                    price={row?.creation_data?.price}
                    tags={row?.creation_data?.tags}
                    users={row?.user_data}
                    onClick={() => handleCardClick(row?.creation_id)}
                    media={row?.creation_data?.media}
                />
            )) : <div className="empty-container d-flex jcc aic f-column">
                <Icon color={categoryProp?.color || "#ff0000"} stroke={categoryProp?.stroke} alias={categoryProp?.icon || ""} width={112} />
                <p className="empty-text mt-24">Buy a {collection_category?.replace('_', ' ')} and it will appear here</p>
            </div>}
        </div>
    );
}

export default CategoryCollection;
